import React from 'react';
import { SignupCompanyInfoView, SignupLayout } from '../components';
import { useSignupCompanyInfoViewController } from '../controllers';

const SignupCompanyInfoPage: React.FC = () => {
  const {
    formValues,
    options,
    optionsLoading,
    errors,
    formError,
    submitting,
    blocked,
    handleChange,
    normalizeWebsite,
    submit,
    goToLogin,
    startOver,
  } =
    useSignupCompanyInfoViewController();

  return (
    <SignupLayout>
      <SignupCompanyInfoView
        formValues={formValues}
        options={options}
        optionsLoading={optionsLoading}
        errors={errors}
        formError={formError}
        submitting={submitting}
        blocked={blocked}
        onChange={handleChange}
        onWebsiteBlur={normalizeWebsite}
        onSubmit={submit}
        onLogIn={goToLogin}
        onStartOver={startOver}
      />
    </SignupLayout>
  );
};

export default SignupCompanyInfoPage;
